import { render, staticRenderFns } from "./editpenebangan.vue?vue&type=template&id=340d64da&"
import script from "./editpenebangan.vue?vue&type=script&lang=js&"
export * from "./editpenebangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports